var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.routes.length > 1)?_c('a-breadcrumb',{attrs:{"routes":_vm.routes},scopedSlots:_vm._u([{key:"itemRender",fn:function(ref){
var route = ref.route;
var routes = ref.routes;
var paths = ref.paths;
return [(routes.indexOf(route) === routes.length - 1)?_c('span',[_vm._v(" "+_vm._s(route.breadcrumbName)+" ")]):_c('router-link',{attrs:{"to":("/" + (paths.join('/')))}},[_vm._v(" "+_vm._s(route.breadcrumbName)+" ")])]}}],null,false,3495076471)}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }